/**
 * @documental
 * @export Semibold
 * @type
 * typographyComponent
 * @use
 * The `Semibold` component should be used to identify text content which is to be called out.
 * @element
 * span
 * @className
 * semibold
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import styles from "./styles.module.scss";

/**
 * The Semibold component properties.
 */

export interface SemiboldProps extends BaseProps {}

/**
 * Specifies that text content should be displayed as semibold. Can be overridden
 * through the use of the [Regular](../Regular/README.md) and [Bold](../Bold/README.md)
 * components.
 */
export const Semibold: FC<PropsWithChildren<SemiboldProps>> = (props) => {
  const { children } = props;
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Semibold, "semibold"] });

  return <span {...baseHtmlProps}>{children}</span>;
};
